<div fxLayout="column" fxLayoutAlign="start center">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
